import {ReactNode} from 'react';
import logoImg from '../../../assets/netcomet2.png';

/**
 * Moldura comum dos slides: fundo degradê do site, ondas e pontos decorativos,
 * logo da Netcomet no topo e a hashtag das campanhas no rodapé.
 */

interface SlideBaseProps {
	vertical: boolean;
	variante?: 'azul' | 'escuro';
	children: ReactNode;
}

export function SlideBase({vertical, variante = 'azul', children}: SlideBaseProps) {
	return (
		<div className={`slide slide-${variante} ${vertical ? 'slide-vertical' : 'slide-horizontal'}`}>
			<div className="slide-ondas" aria-hidden="true"/>
			<div className="slide-pontos slide-pontos-1" aria-hidden="true"/>
			<div className="slide-pontos slide-pontos-2" aria-hidden="true"/>
			<div className="slide-arco" aria-hidden="true"/>
			<img src={logoImg} alt="Netcomet" className="slide-logo"/>
			<div className="slide-conteudo">{children}</div>
			<div className="slide-hashtag">#vempranetcomet</div>
		</div>
	);
}
